import { render, staticRenderFns } from "./removeItemCell.vue?vue&type=template&id=611ab966&"
import script from "./removeItemCell.vue?vue&type=script&lang=ts&"
export * from "./removeItemCell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports